var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoosts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 103,
    viewBox: "0 0 68 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4988 0.224404C44.324 -0.279314 42.9559 0.0854997 42.1869 1.11292L0.555606 56.788C-0.076362 57.6326 -0.176649 58.7606 0.292946 59.7043C0.763336 60.6479 1.72479 61.2434 2.7755 61.2434H27.2547L20.8555 99.758C20.6438 101.026 21.3243 102.27 22.5015 102.776C22.8549 102.927 23.225 103 23.5927 103C24.4451 103 25.2761 102.604 25.8132 101.887L67.4445 46.2121C68.0749 45.3675 68.1776 44.2395 67.7072 43.2958C67.2368 42.3538 66.2754 41.7567 65.2232 41.7567H40.7461L47.1452 3.24208C47.3553 1.97677 46.6756 0.730636 45.4993 0.225242L45.4988 0.224404ZM59.6724 47.3244L28.2003 89.4133L33.2671 58.918C33.4016 58.1101 33.1748 57.2854 32.6479 56.6604C32.121 56.0353 31.3466 55.6761 30.5298 55.6761L8.32661 55.6753L39.7987 13.5863L34.7319 44.0837C34.5974 44.8908 34.8234 45.7154 35.3511 46.3405C35.878 46.9656 36.6525 47.3248 37.4683 47.3248L59.6724 47.3244Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosts);
export default __webpack_public_path__ + "static/media/boosts.73ff3a5b4f7f58ef79e4107881894a2b.svg";
export { ForwardRef as ReactComponent };